
define('ldsh!modules/start/products/automation/activity/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-xs-7 col-sm-9 col-md-10 col-lg-10">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <h3 class="i18n" style="margin-top: 5px;" data-i18n="PUBLIC.PRODUCTS.AUTOMATION.PRODUCT_NAME"></h3>\n        </div>\n    </div>\n\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <table style=\'margin-bottom: 10px;\'>\n                <tr>\n                    <td style="vertical-align: top;">\n                        <img class="product-check" src="/app/img/check_20.png"/>\n                    </td>\n                    <td>\n                        <span class="i18n" data-i18n="PUBLIC.PRODUCTS.AUTOMATION.INFO.SUBTITLE_IF_ACTIVE"></span>\n                    </td>\n                </tr>\n            </table>\n            <p>\n                <b class="i18n" data-i18n="PUBLIC.PRODUCTS.SCENES_NUMBER"></b>\n                ';
 if (productDetails.isRequest) { ;
__p += '\n                    <i class="ri-loader-4-fill fa-spin product-spinner" style="font-size: 10px;"></i>\n                ';
 } else { ;
__p += '\n                    <span class="product-number">' +
__e(formatNumber(activeScenes)) +
'</span>\n                ';
 } ;
__p += '\n            </p>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

